import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfDataTablesService {

  // Seteo DataTables idioma español
  public confDataTables() {
    $.fn.dataTable.ext.errMode = 'none';

    $.extend(true, $.fn.dataTable.defaults, {
      responsive: true,
      language: {
        "search": '<i class="fa fa-search"></i>',
        "searchPlaceholder": "Buscar",
      },
      oLanguage: {
        "sProcessing": '<i class="fa fa-spinner fa-pulse fa-2x fa-fw"></i><span class="sr-only">Procesando...</span>',
        "sLengthMenu": "Mostrar _MENU_ registros",
        "sZeroRecords": "No se encontraron resultados",
        "sEmptyTable": 'Ningún dato disponible en esta tabla <i class="fa fa-frown-o" aria-hidden="true"></i>',
        "sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
        "sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
        "sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
        "sInfoPostFix": "",
        // "sSearch": "Buscar:",
        "sUrl": "",
        "sInfoThousands": ",",
        "sLoadingRecords": '<i class="fa fa-spinner fa-pulse fa-2x fa-fw"></i><span class="sr-only">Cargando...</span>',
        "oPaginate": {
          "sFirst": "Primero",
          "sLast": "Último",
          "sNext": '<i class="fa fa-arrow-right" aria-hidden="true"></i>',
          "sPrevious": '<i class="fa fa-arrow-left" aria-hidden="true"></i>'
        },
        "oAria": {
          "sSortAscending": ": Activar para ordenar la columna de manera ascendente",
          "sSortDescending": ": Activar para ordenar la columna de manera descendente"
        },
        select: {
          rows: "%d filas seleccionada"
        }
        // ,
        // "decimal": ",",
        // "thousands": "."
      }
    });
    return
  }

}
